import { render, staticRenderFns } from "./shw.vue?vue&type=template&id=24c5969a&scoped=true"
import script from "./shw.vue?vue&type=script&lang=js"
export * from "./shw.vue?vue&type=script&lang=js"
import style0 from "./shw.vue?vue&type=style&index=0&id=24c5969a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5969a",
  null
  
)

export default component.exports